// extracted by mini-css-extract-plugin
export default {"errorMessage":"ErrorLabel_errorMessage__nlDiN","errorLabelContainer":"ErrorLabel_errorLabelContainer__RoEIU","errorLabel":"ErrorLabel_errorLabel__kOaki"};